<template>
  <el-form
    ref="form"
    :rules="rules"
    :model="model"
    label-width="80px"
    label-position="right"
  >
    <el-form-item
      label="Nombre"
      prop="name"
    >
      <el-input
        v-model="model.name"
      />
    </el-form-item>
  </el-form>
</template>

<script>
import Dealer from './dealers.model'
import { mapActions } from 'vuex'

export default {
  name: 'DealersForm',
  components: {},
  props: {
    oldModel: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      model: Dealer.model(),
      rules: Dealer.rules
    }
  },
  mounted () {
    this.model = Object.assign(Dealer.model(), this.oldModel)
  },
  methods: {
    ...mapActions('dealers', ['save', 'query']),
    onSubmit () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.save(this.model)
            .then(response => {
              return this.query().then(() => {
                return this.$router.push({ name: 'dealers' })
              })
            })
            .catch(error => {
              console.log(error)
              if (
                error.response &&
                error.response.data.fields &&
                error.response.data.fields[0].field === 'name' &&
                error.response.data.fields[0].validation === 'unique'
              ) {
                this.$notify.error({
                  group: 'app',
                  title: 'El nombre del distribuidor ya existe.',
                  message:
                    'El nombre del distribuidor debe ser único, intente con otro nombre.'
                })
              } else {
                this.$notify.error({
                  group: 'app',
                  title: 'Error al crear distribuidor.',
                  message: 'Por favor, vuelve a intentarlo.'
                })
              }
              return Promise.reject(error)
            })
        } else {
          this.$notify({
            group: 'app',
            title: 'Verifica la forma.',
            text:
              'Por favor, revisa lo errores que se indican dentro de la forma.'
          })
          return false
        }
      })
    }
  }
}
</script>

<style
  lang="scss"
  scoped
>
</style>



// WEBPACK FOOTER //
// src/modules/dealers/dealers-form.vue